import React, { useState } from 'react'
import { connect } from 'react-redux'
import { func, string, bool, element } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import { RequestInstallModal } from '@/components/modals/RequestInstallModal'
import { getPublishedApp } from '@/store/selectors'
import { logAmplitudeEvent } from '@/store/stats'
import { AMPLITUDE_EVENTS } from '@/constants'

export const NoAccessButton = ({
  appName,
  id,
  icon,
  className,
  disabled,
  size,
  fullWidth,
  requestAmplitudeEvent,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModal = () => setIsModalOpen(!isModalOpen)

  const handleClick = (e) => {
    e.preventDefault()

    requestAmplitudeEvent({
      name: AMPLITUDE_EVENTS.NO_ACCESS_MODAL_DISPLAYED,
      params: {
        appId: id,
        appName,
      },
    })

    toggleModal()
  }

  return (
    <>
      {isModalOpen && (
        <RequestInstallModal
          appId={id}
          appName={appName}
          handleCloseModal={toggleModal}
        />
      )}

      <Button
        data-test="install-btn"
        icon={icon || ''}
        onClick={handleClick}
        className={className}
        disabled={disabled}
        size={size}
        kind="primary"
        fullWidth={fullWidth}
      >
        Get
      </Button>
    </>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const { name } = getPublishedApp(state, id)

  return {
    appName: name,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    requestAmplitudeEvent: (payload) => {
      dispatch(logAmplitudeEvent(payload))
    },
  }
}

NoAccessButton.propTypes = {
  appName: string,
  id: string,
  icon: element,
  className: string,
  disabled: bool,
  size: string,
  fullWidth: bool,
  requestAmplitudeEvent: func,
}

export default connect(mapStateToProps, mapDispatchToProps)(NoAccessButton)
